import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { LogoGlyph } from "../../components/zen/Logo";
import { clearAdminToken } from "../adminFetch";

export const AdminLayout = ({ children, userId = "zenmegroup" }) => {
    const navigate = useNavigate();
    const onSignOut = () => {
        clearAdminToken();
        navigate("/admin/login");
    };
    return (
        <div className="min-h-screen bg-base text-text-primary">
            <header
                className="sticky top-0 z-30 border-b border-border-subtle bg-[rgba(10,10,11,0.75)] backdrop-blur-[16px]"
                data-testid="admin-topbar"
            >
                <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-5 lg:px-8">
                    <Link
                        to="/admin/leads"
                        className="inline-flex items-center gap-2.5 text-text-primary"
                        data-testid="admin-home-link"
                    >
                        <LogoGlyph size={20} className="text-text-primary" />
                        <span
                            className="font-display text-[13.5px] font-semibold tracking-tight-2"
                            style={{ letterSpacing: "0.05em" }}
                        >
                            ZENME&nbsp;GROUP · ADMIN
                        </span>
                    </Link>
                    <div className="flex items-center gap-4">
                        <span className="hidden sm:inline text-[12px] uppercase tracking-widest-2 text-text-muted">
                            Signed in as {userId}
                        </span>
                        <button
                            type="button"
                            onClick={onSignOut}
                            data-testid="admin-signout-btn"
                            className="inline-flex items-center gap-2 rounded-full border border-border-default px-4 py-1.5 text-[13px] font-medium text-text-secondary transition-all duration-200 hover:text-text-primary hover:border-[rgba(124,255,79,0.4)]"
                        >
                            <LogOut className="h-3.5 w-3.5" strokeWidth={1.5} />
                            Sign out
                        </button>
                    </div>
                </div>
            </header>
            <main className="mx-auto max-w-7xl px-5 py-10 lg:px-8 lg:py-12">
                {children}
            </main>
        </div>
    );
};

export default AdminLayout;
